import React from 'react';
import { formatShareCount } from '../../utils/ipoSubscription';
import { formatCrore, formatRupees, formatTimes } from '../../utils/issueSubscription';

const Card = ({ label, value, chip, note }) => (
  <li className="min-w-0 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4">
    <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-1">
      <span className="text-xl sm:text-2xl font-extrabold text-slate-900 tracking-tight">{value}</span>
      {chip && <span className="text-[11px] font-bold text-[#008080]">{chip}</span>}
    </p>
    <p className="mt-1 text-[11px] text-slate-400 truncate">{note}</p>
  </li>
);

// Price band, lot, issue size and valuation (or live demand when the DRHP has no valuation)
export const IssueKeyStats = ({ issue, profile, book }) => {
  const band =
    issue.priceHigh && issue.priceLow && issue.priceLow !== issue.priceHigh
      ? `₹${issue.priceLow} – ₹${issue.priceHigh}`
      : issue.priceHigh
      ? `₹${issue.priceHigh}`
      : '—';
  const isSme = issue.board === 'sme';
  const minLots = isSme ? 2 : 1;
  const offered = book?.total?.offered;

  return (
    <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      <Card
        label="Price Band"
        value={band}
        note={profile?.faceValue ? `Face value ₹${profile.faceValue} per equity share` : 'Per equity share'}
      />
      <Card
        label="Minimum Lot Size"
        value={issue.lotSize ? `${issue.lotSize.toLocaleString('en-IN')} Shares` : '—'}
        chip={issue.lotSize ? `${minLots} Lot${minLots > 1 ? 's' : ''} min` : null}
        note={issue.minInvestment ? `Min investment ${formatRupees(issue.minInvestment * minLots)}` : 'Lot size awaited'}
      />
      <Card
        label="Total Issue Size"
        value={formatCrore(issue.sizeCr)}
        note={offered ? `${formatShareCount(offered)} shares in the public book` : 'Including the anchor portion'}
      />
      {profile?.mcapPostCr ? (
        <Card
          label="Post-Issue Market Cap"
          value={formatCrore(profile.mcapPostCr)}
          note={profile.mcapPreCr ? `Pre-IPO valuation ${formatCrore(profile.mcapPreCr)}` : 'At the upper price band'}
        />
      ) : (
        <Card
          label="Total Demand"
          value={book?.hasBids ? formatTimes(book.total?.times ?? null) : '—'}
          note={book?.hasBids ? `${formatShareCount(book.total?.bid)} shares bid so far` : 'Live once bidding opens'}
        />
      )}
    </ul>
  );
};

export default IssueKeyStats;
